import React, { useMemo } from 'react'
import Common from './common/DestinationsGrid'

const DestinationsGridLoader = ({
  id,
  items,
  title,
  isLessThanLaptop,
  language,
  organizationSlug,
  itemsPerRow,
  itemsPerPage,
}) => {
  // Memoize the lazy-loaded component based on organizationSlug
  const DestinationGridLazyLoaded = useMemo(() => {
    if (!organizationSlug) return null
    switch (organizationSlug) {
      default:
        return Common
    }
  }, [organizationSlug])

  return (
    <>
      <DestinationGridLazyLoaded
        id={id}
        items={items}
        title={title}
        isLessThanLaptop={isLessThanLaptop}
        language={language}
        organizationSlug={organizationSlug}
        itemsPerRow={itemsPerRow}
        itemsPerPage={itemsPerPage}
      />
    </>
  )
}

export default DestinationsGridLoader
